// using a different file to avoid circular dependencies

export abstract class FrameParser {
    canvas: OffscreenCanvas
    abstract parseColorspace(frame: VideoFrame): Promise<Uint32Array>
    abstract finishAndGetAnomalyScores(): Promise<Uint8Array | null>
    constructor(canvas: OffscreenCanvas) {
        this.canvas = canvas
    }
    abstract init?(): Promise<void>
}

export class MockFrameParser implements FrameParser {
    canvas: OffscreenCanvas = {} as unknown as OffscreenCanvas
    parseColorspace(): Promise<Uint32Array> {
        throw new Error("Method not implemented.")
    }
    init?(): Promise<void> {
        throw new Error("Method not implemented.")
    }
    finishAndGetAnomalyScores(): Promise<Uint8Array | null> {
        throw new Error("Method not implemented.")
    }
}
